import React from 'react';
import {Container, Row, Col} from 'reactstrap';
//swiper
import "swiper/css";
import "swiper/css/pagination";
import image3 from "../../../assets/images/Project/3.png";
import image4 from "../../../assets/images/Project/4.png";
import image5 from "../../../assets/images/Project/5.png";
import image6 from "../../../assets/images/Project/6.1.png";
import {useTranslation} from 'react-i18next';
import {appConfig} from '../../../config';

const Trending = () => {
    const {t} = useTranslation();

    return (
        <React.Fragment>
            <section className="section bg-light" id="categories">
                <Container fluid>
                    <Row className="justify-content-center">
                        <Col lg={5}>
                            <div className="text-center mb-5">
                                <h2 className="mb-3 fw-semibold lh-base">
                                    {t('t-fact-solutions-head').split('{appName}')[0]}
                                    <span className='text-primary'>{appConfig.appName}</span>
                                    {t('t-fact-solutions-head').split('{appName}')[1]}
                                </h2>
                            </div>
                        </Col>
                    </Row>
                    <Row className='justify-content-center'>
                        <Col lg={9}>
                            <Row>
                                <Col lg={4} className="product-item">
                                    <div className="card explore-box card-animate h-100">
                                        <div className="text-center mt-4 p-2">
                                            <span className="rounded-circle badge badge-soft-success p-3">
                                                <img className='avatar-sm' src={image4} alt=''/>
                                            </span>
                                        </div>
                                        <div className="card-body">
                                            <h3 className="text-center">
                                                {t('t-fact-solutions1')}
                                            </h3>
                                            <p className="text-muted my-2 text-center fs-17 pt-3">
                                                {t('t-fact-solutions1-desc')}
                                            </p>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={4} className="product-item">
                                    <div className="card explore-box card-animate h-100">
                                        <div className="text-center mt-4 p-2">
                                            <span className="rounded-circle badge badge-soft-success p-3">
                                                {/* <i className="ri-smartphone-line" style={{ fontSize: "3rem" }}></i> */}
                                                <img className='avatar-sm' src={image5} alt=''/>
                                            </span>
                                        </div>
                                        <div className="card-body">
                                            <h3 className="text-center">
                                                {t('t-fact-solutions2')}
                                            </h3>
                                            <p className="text-muted my-2 text-center fs-17 pt-3">
                                                {t('t-fact-solutions2-desc')}
                                            </p>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={4} className="product-item">
                                    <div className="card explore-box card-animate h-100">
                                        <div className="text-center mt-4 p-2">
                                            <span className="rounded-circle badge badge-soft-success p-3">
                                                <img className='avatar-sm' src={image6} alt=''/>
                                            </span>
                                        </div>
                                        <div className="card-body">
                                            <h3 className="text-center">
                                                {t('t-fact-solutions3')}
                                            </h3>
                                            <p className="text-muted my-2 text-center fs-17 pt-3">
                                                {t('t-fact-solutions3-desc').split('{appName}')[0]}
                                                <span className='fw-semibold'>{appConfig.appName}</span>
                                                {t('t-fact-solutions3-desc').split('{appName}')[1]}
                                            </p>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};

export default Trending;